import type { ListApplication } from "~/types/application.types";

type ApplicationStatus = ListApplication["applicationStatus"];

type StatusBadgeProps = {
  status: ApplicationStatus;
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  const statusMap = {
    IN_PROGRESS: {
      label: "In progress",
      className: "text-yellow-600",
    },
    WAITING_FOR_COLLABORATOR: {
      label: "Pending collaborators",
      className: "text-orange-600",
    },
    UNDER_REVIEW: {
      label: "Under review",
      className: "text-black",
    },
    APPROVED: {
      label: "Approved",
      className: "text-green-600",
    },
    REJECTED: {
      label: "Cannot be ProudlyHuman™ certified",
      className: "text-black",
    },
    PENDING_IDENTITY_VERIFICATION: {
      label: "Pending Identity Verification",
      className: "text-black",
    },
    APPEALED: {
      label: "Appealed",
      className: "text-yellow-600",
    },
  } as const;

  const statusInfo = statusMap[status as keyof typeof statusMap];

  return (
    <span className={`text-sm font-semibold ${statusInfo.className}`}>
      {statusInfo.label}
    </span>
  );
}
